export enum RefundTypes {
  transactions = 'transactions',
  settlements = 'settlements',
  refunds = 'refunds',
  disputes = 'disputes',
  paymentlinks = 'paymentlinks',
}
